import { useQuery } from "@tanstack/react-query";
import { getPolicies } from "../../services";

const ENDPOINT_URL = "/api/policies";

export const useHelpCenter = () => {
  const useReactQuery = () => {
    return useQuery({
      queryKey: [ENDPOINT_URL],
      queryFn: () => getPolicies(),
    });
  };

  return {
    useQuery: useReactQuery,
  };
};
